<template>
  <v-card>
    <v-card-text>
      <!-- Add new access key -->
      <v-btn :disabled="loading" color="primary" class="mx-0 mb-6" @click="addAccessKey()">
        Add new API key
      </v-btn>

      <!-- Table: Access keys -->
      <v-data-table
        :headers="headers"
        :items="apiKeys"
        :loading="loading"
        must-sort
        no-data-text="No existing API access keys."
        hide-default-footer
        items-per-page="-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ dateTimeVerbose(item.created_at) }}</td>
            <td>{{ item.shared_access_key }}</td>
            <td>
              <v-btn
                v-if="!item.secret_access_key"
                :loading="loadingSecretAccessKey.isLoading && loadingSecretAccessKey.id === item.id"
                :disabled="
                  loadingSecretAccessKey.isLoading && loadingSecretAccessKey.id === item.id
                "
                text
                color="primary"
                class="ma-0"
                @click="showSecretAccessKey(item)"
              >
                Show
              </v-btn>
              <span v-else>{{ item.secret_access_key }}</span>
            </td>
            <td>
              <v-row justify="center">
                <v-tooltip bottom>
                  <template #activator="{ props }">
                    <v-btn
                      :icon="mdiDelete"
                      small
                      variant="text"
                      v-bind="props"
                      @click="deleteAccessKey(item)"
                    />
                  </template>
                  Delete Access Key
                </v-tooltip>
              </v-row>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
// Modules
import api from '@/store/api'
import { mapStoreState } from '@/store/helpers'

// Mixins
import FormattersMixin from '@/mixins/formatters'
import { mdiDelete } from '@mdi/js'

export default {
  mixins: [FormattersMixin],

  data() {
    return {
      mdiDelete,
      loading: false,
      loadingSecretAccessKey: {
        isLoading: false,
        id: null
      },
      headers: [
        {
          title: 'Created',
          key: 'created_at',
          class: 'date-cell-min-width'
        },
        {
          title: 'Shared access key',
          key: 'shared_access_key',
          sortable: false
        },
        {
          title: 'Secret access key',
          key: '',
          sortable: false
        },
        {
          title: '',
          key: '',
          sortable: false,
          class: 'actions-cell-min-width'
        }
      ],
      apiKeys: []
    }
  },

  computed: {
    ...mapStoreState({
      user: state => state.user.user
    })
  },

  mounted() {
    this.loadApiKeys()
  },

  methods: {
    loadApiKeys() {
      this.loading = true

      api
        .get('api_key.json?id=all')
        .then(res => {
          if (res.data) {
            res.data.forEach(keyObj => {
              keyObj.show_secret_access_key = false
              keyObj.secret_access_key = null
            })

            this.apiKeys = res.data
          }
        })
        .catch(error => console.log(error))
        .then(() => (this.loading = false))
    },

    showSecretAccessKey(apiKey) {
      this.loadingSecretAccessKey.isLoading = true
      this.loadingSecretAccessKey.id = apiKey.id

      api
        .get(`api_key.json?include_secret_access_key=true&id=${apiKey.id}`)
        .then(res => {
          if (res.data) {
            apiKey.show_secret_access_key = true
            apiKey.secret_access_key = res.data.secret_access_key
          }
        })
        .catch(error => console.log(error))
        .then(() => {
          this.loadingSecretAccessKey.isLoading = false
          this.loadingSecretAccessKey.id = null
        })
    },

    addAccessKey() {
      this.loading = true

      api
        .post('api_key.json?id=new')
        .then(() => this.loadApiKeys())
        .catch(error => console.log(error))
        .then(() => (this.loading = false))
    },

    deleteAccessKey(apiKey) {
      if (!window.confirm('Are you sure you want to delete this access key?')) {
        return
      }

      this.loading = true

      api
        .delete(`api_key.json?include_secret_access_key=true&id=${apiKey.id}`)
        .then(() => this.loadApiKeys())
        .catch(error => console.log(error))
        .then(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.date-cell-min-width {
  min-width: 225px;
}
.actions-cell-min-width {
  min-width: 100px;
}
</style>
